import { Bell } from 'lucide-react';
import NotificationItem from './NotificationItem';

const NotificationPanel = ({ notifications, onClose, dispatch }) => (
  <div className="absolute right-0 mt-2 w-80 glass rounded-2xl shadow-glass border border-white/30 z-30 animate-slide-down overflow-hidden" role="dialog" aria-label="Notifications">
    <div className="p-4 border-b border-gray-200/50 bg-gradient-to-r from-brand-50/80 to-accent-50/80">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold text-gray-800">Notifications</h3>
        <button
          onClick={() => dispatch({ type: 'MARK_ALL_NOTIFICATIONS_READ' })}
          className="text-sm text-brand-600 hover:text-brand-700 font-medium transition-colors"
        >
          Mark all read
        </button>
      </div>
    </div>
    <div className="max-h-96 overflow-y-auto">
      {notifications.length > 0 ? (
        notifications.map(notif => (
          <NotificationItem
            key={notif.id}
            notification={notif}
            dispatch={dispatch}
            onClose={onClose}
          />
        ))
      ) : (
        <div className="p-8 text-center text-gray-500">
          <div className="w-16 h-16 bg-gray-100 rounded-2xl mx-auto mb-3 flex items-center justify-center">
            <Bell className="h-8 w-8 text-gray-300" />
          </div>
          <p className="font-medium">All caught up!</p>
          <p className="text-xs text-gray-400 mt-1">No new notifications</p>
        </div>
      )}
    </div>
  </div>
);

export default NotificationPanel;
